import { useCompany } from './use-settings';

export type ActivityType = 'services' | 'goods' | 'mixt' | null;

/**
 * useActivityType — single source of truth pentru Activity Mode.
 *
 * Citește `tenant.primaryActivityType` din useCompany() (cached cu react-query).
 * Expune flag-uri derivate pentru gating UI peste tot frontend-ul.
 *
 * Regulă de gating:
 * - `services` → ascund stocuri/NIR/warehouse
 * - `goods` | `mixt` | `null` → comportament curent neschimbat
 *
 * Schimbarea modului în Settings invalidează query → UI se reactualizează
 * automat fără refresh.
 */
export function useActivityType() {
  const { data: company, isLoading } = useCompany();
  const type = (company?.primaryActivityType ?? null) as ActivityType;

  return {
    type,
    isLoading,
    // Boolean flags
    isServices: type === 'services',
    isGoods: type === 'goods',
    isMixt: type === 'mixt',
    isUnset: type == null,
    // Derived UI gates
    shouldShowStock: type !== 'services',
    shouldShowNir: type !== 'services',
    shouldShowWarehouse: type !== 'services',
  };
}
